import { TYPE_COLLECTION } from './input-types';

export const id = 'carrier';
export const apiKey = 'CarrierId';
export const type = TYPE_COLLECTION;

export const carrier = {
  id,
  apiKey,
  type,
};
